import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const authHeaders = () => ({ Authorization: getAccessTokenApi() });

const useMyEquipoComponentsApi = () => {
  const getTree = useCallback(async (equipoId) => {
    const { data } = await axios.get(`${API_PATH}/ascensores/${equipoId}/components`, {
      headers: authHeaders(),
    });
    return data; // { tree }
  }, []);

  const addNode = useCallback(async (equipoId, payload) => {
    const { data } = await axios.post(`${API_PATH}/ascensores/${equipoId}/components`, payload, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const updateNode = useCallback(async (nodeId, payload) => {
    const { data } = await axios.put(`${API_PATH}/components/${nodeId}`, payload, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const removeNode = useCallback(async (nodeId) => {
    const { data } = await axios.delete(`${API_PATH}/components/${nodeId}`, {
      headers: authHeaders(),
    });
    return data;
  }, []);

  const cloneTemplate = useCallback(async (equipoId, rootId) => {
    const { data } = await axios.post(
      `${API_PATH}/ascensores/${equipoId}/components/clone-template/${rootId}`,
      {},
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const getPermissions = useCallback(async () => {
    const { data } = await axios.get(`${API_PATH}/me/component-permissions`, {
      headers: authHeaders(),
    });
    return data; // { canEdit: boolean }
  }, []);

  const replaceComponent = useCallback(async (equipoId, nodeId, payload) => {
    const { data } = await axios.post(
      `${API_PATH}/ascensores/${equipoId}/components/${nodeId}/replace`,
      payload,
      { headers: authHeaders() }
    );
    return data;
  }, []);

  const listReplacements = useCallback(async (equipoId, nodeId) => {
    const { data } = await axios.get(
      `${API_PATH}/ascensores/${equipoId}/components/${nodeId}/replacements`,
      { headers: authHeaders() }
    );
    return data; // { replacements }
  }, []);

  return useMemo(
    () => ({
      getTree,
      addNode,
      updateNode,
      removeNode,
      cloneTemplate,
      getPermissions,
      replaceComponent,
      listReplacements,
    }),
    [
      getTree,
      addNode,
      updateNode,
      removeNode,
      cloneTemplate,
      getPermissions,
      replaceComponent,
      listReplacements,
    ]
  );
};

export default useMyEquipoComponentsApi;
